module.exports = __webpack_public_path__ + "img/multiselectable-filters.fb72aaad.gif";